import { ReactNode, useEffect, useRef, useState } from 'react'
import { BannerLayer } from 'react-scroll-parallax/dist/components/ParallaxBanner/types'
import styled from 'styled-components'
import { useWindowSize } from 'usehooks-ts'
import { Accordeon } from 'components/Accordeon'
import { ParallaxBanner } from 'react-scroll-parallax'
import { Waypoint } from 'react-waypoint'
import { TextWidth } from '@ta-interaktiv/react-disco-grid'
import { Stink } from 'components/Stink'
import { Scrollama, Step } from 'react-scrollama'
import { useSpring, animated } from '@react-spring/web'

const Titles_DE: { [key: string]: string } = {
  gesellschaft: 'Gesellschaft',
  politik: 'Politik',
  kultur: 'Kultur',
  international: 'International',
  wirtschaft: 'Wirtschaft',
  lifestyle: 'Lifestyle',
  sport: 'Sport',
}

export const Chapter = ({
  menuentry,
  questions,
  setCurrent,
  colorMode,
  tenant,
}: {
  menuentry: string
  questions: {
    title: string
    author: string
    autorBio: string
    content: ReactNode
    link?: number
  }[]

  colorMode: 'dark' | 'light' | undefined
  tenant: Tenant
  setCurrent: () => void
}) => {
  const ref = useRef<HTMLDivElement>(null)
  const { width } = useWindowSize()
  const [progress, setProgress] = useState(0)
  const [height, setHeight] = useState(0)

  useEffect(() => {
    if (!ref.current) return
    let w = window as any
    if (!w.menucontent) w.menucontent = {}
    w.menucontent[menuentry] = ref.current
  }, [ref.current])

  useEffect(() => {
    setHeight(window.innerHeight)
  }, [])
  // useEffect(() => {
  //   if (!ref.current) return
  //   setHeight(ref.current.getBoundingClientRect().height)
  // }, [ref.current])
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent)

  const handleWaypointEnter = () => {}

  const handleWaypointLeave = () => {}

  const handleOnProgress = (e: any) => {
    setProgress(e.progress)
  }
  return (
    <ChapterRoot
      className={'chapter ' + (isSafari ? 'saf' : '')}
      colorMode={colorMode}
      ref={ref}
    >
      <>
        <Waypoint
          scrollableAncestor={window}
          onEnter={() => {
            setCurrent()
          }}
        >
          <a id={menuentry} />
        </Waypoint>
        <Scrollama
          onStepEnter={handleWaypointEnter}
          onStepExit={handleWaypointLeave}
          onStepProgress={handleOnProgress}
          offset={1}
        >
          <Step data={1}>
            <Container>
              <div>
                <img
                  src={require('../../assets/' +
                    menuentry +
                    '-BG' +
                    (colorMode === 'dark' ? '_dm' : '') +
                    '.jpg')}
                  style={{
                    transform: 'translateX(-50%)',
                    left: '50%',
                    top: progress * 200 + 'px',
                  }}
                />
                <img
                  src={require('../../assets/' + menuentry + '-FG.png')}
                  style={{
                    transform: 'translateX(-50%)',
                    left: '50%',
                    top: 300 - progress * 100 + 'px',
                  }}
                />

                <Title
                  style={{
                    transform: 'translateX(-50%)',
                    position: 'absolute',
                    left: '50%',
                    top: (width < 712 ? 50 : 120) + progress * 300 + 'px',
                  }}
                >
                  {Titles_DE[menuentry]}
                </Title>
              </div>
            </Container>
          </Step>
          <ScrollFront>
            <TextWidth>
              <ScrollContent>
                <div
                  style={{
                    backgroundColor: 'var(--site-background)',
                    paddingTop: '15px',
                    paddingBottom: '60px',
                    zIndex: 20,
                  }}
                >
                  {questions.map((question, index) => {
                    return (
                      <Accordeon
                        key={'question_' + index}
                        head={<Question>{question.title}</Question>}
                        tail={
                          <>
                            <Author
                              href={
                                'https://www.' +
                                tenant.key +
                                '.ch/author/' +
                                question.autorBio
                              }
                            >
                              <span>{question.author}</span>
                            </Author>
                            {question.content}
                            {question.link && (
                              <Stink href={question.link + ''}>
                                Hier gibts mehr zum Thema
                              </Stink>
                            )}
                          </>
                        }
                        colorMode={colorMode}
                      />
                    )
                  })}
                </div>
              </ScrollContent>
            </TextWidth>
          </ScrollFront>
        </Scrollama>

        {/* <Waypoint
          scrollableAncestor={window}
          onEnter={() => {
            setCurrent()
          }}
        >
          <Scrollcontainer>
            <a id={menuentry} />
            <ChapterTitle
              ref={ref}
              style={{
                height: effectDisabled
                  ? width < 500
                    ? '400px'
                    : width < 711
                    ? '600px'
                    : '500px'
                  : '900px',
              }}
            >
              <ParallaxBanner
              style={{ height: '100%', willChange: 'transform' }}
              layers={[background, foreground, headline]}
              className='aspect-[2/1] bg-gray-900'
            />
            </ChapterTitle>

           
          </Scrollcontainer>
        </Waypoint> */}
      </>
    </ChapterRoot>
  )
}

const Container = styled.div`
  padding-top: 400px;
  position: relative;
  text-align: center;
  height: 300px;
  img {
    position: absolute;
    max-width: 600px;
  }
  @media only screen and (max-width: 711px) {
    padding-top: 300px;
    height: 300px;

    img {
      position: absolute;
      max-width: 500px;
    }
  }
`

const ChapterRoot = styled.div<{ colorMode: 'dark' | 'light' | undefined }>`
  max-width: 100%;
  overflow: hidden;
  z-index: 0;
  position: relative;
  -webkit-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
  a {
    text-decoration: none;
    background-image: ${({ colorMode }) =>
      colorMode === 'light'
        ? 'linear-gradient(90deg, #ffe462, #ffe462)'
        : 'linear-gradient(90deg, #9698A8, #9698A8)'};
    background-repeat: repeat-x;
    background-position: bottom;
    background-size: 100% 20%;
    transition: all 0.1s ease-in-out;
    color: inherit !important;
    background-origin: content-box;
    &:hover {
      background-size: 100% 100%;
    }
    .linkicon {
      rect {
        fill: var(--text-color);
      }
    }
  }
  &.saf {
    /* margin-top: 300px; */
  }

  .title_saf {
    margin-top: 200px;
    @media only screen and (max-width: 711px) {
      margin: 100px;
    }
  }
`
const Scrollcontainer = styled.div`
  width: 100%;
  max-width: 100%;
  min-height: 900px;
  text-align: center;
  z-index: 1;
  position: relative;
  /* margin-bottom: 120px; */
  -webkit-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
`
const ScrollFront = styled.div`
  z-index: 10;
  position: relative;

  /* margin-top: 200p-top:x; */

  img {
    z-index: 2;
    position: relative;
    max-width: 100%;
    @media only screen and (max-width: 899px) {
      max-width: 100%;
      margin-left: -20%;
    }
  }
`
const ScrollContent = styled.div`
  z-index: 900;
  position: relative;
  line-height: 0;
  max-width: 100%;
  -webkit-transform: translate3d(0, 0, 200px);
  transform: translate3d(0, 0, 200px);
`
const Author = styled.a`
  display: inline-block;
  width: calc(80%);
  text-decoration: none;
  padding: 0;
  color: var(--text-color);
  font-family: var(--font-sans-serif);
  font-size: 15px;
  margin: 0;
  padding: 10px;
  padding-top: 0;
  text-align: center;
  line-height: 1.4em;
  padding-left: 10%;
  padding-right: 10%;
  margin-bottom: 15px;
  background-image: unset !important;
  span {
    border-bottom: 1px solid var(--text-color);
    &:hover {
      opacity: 0.8;
    }
  }
`
const ChapterTitle = styled.div`
  position: relative;
  height: 800px;
  position: relative;
  img {
    width: 600px;
  }
  @media only screen and (max-width: 899px) {
    height: 700px;
    padding-top: 120px;
    img {
      width: 700px !important;
      /* transform: translateX(-8%); */
    }
  }
  @media only screen and (max-width: 711px) {
    height: 600px;
    padding-top: 90px;

    img {
      width: 130% !important;
      transform: translateX(-11.5%);
    }
  }
  @media only screen and (max-width: 549px) {
    height: 400px;
    padding-top: 90px;

    img {
      width: 130% !important;
      transform: translateX(-11.5%);
    }
  }
`
const Title = styled.div`
  font-size: 55px;
  font-family: var(--font-sans-serif);
  font-weight: 300;
  filter: drop-shadow(0 0 0.3rem #fff);
  letter-spacing: 1px;
  color: #fff;
  text-align: center;
  @media only screen and (max-width: 899px) {
    font-size: 65px;
    /* padding-top: 50px; */
  }
  @media only screen and (max-width: 711px) {
    font-size: 55px;
    /* padding-top: 210px; */
  }
  @media only screen and (max-width: 549px) {
    font-size: 40px;
    /* padding-top: 130px; */
  }
`

const Question = styled.h3`
  font-size: 22px;
  margin: 0;
  padding: 10px;
  font-weight: 300;
  text-align: center;
  line-height: 1.4em;
  padding-left: 10%;
  padding-right: 10%;
  padding-bottom: 45px;
  padding-top: 45px;
`
